import { useState, useEffect } from 'react';
import staticConfig from '../data/config.json';
import { checkBackendAvailability } from '../utils/backendHealth';
import { ConfigContext } from './ConfigContextInstance';

/**
 * ConfigProvider - Static configuration provider
 *
 * Uses bundled static config (synced from backend at build time).
 * No API fetch - fully offline-first architecture.
 */
export function ConfigProvider({ children }) {
  // Use static config directly (synced at build time)
  const [config] = useState(staticConfig);
  const [isLoading, setIsLoading] = useState(true);
  const [isHydrated, setIsHydrated] = useState(false);
  const [isBackendAvailable, setIsBackendAvailable] = useState(false);

  /**
   * Mark as loaded on mount
   */
  useEffect(() => {
    // Simulate minimal loading delay for consistent behavior
    const timer = setTimeout(() => {
      setIsLoading(false);
      setIsHydrated(true);
      console.log('✓ Static config loaded (offline-first)');
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  /**
   * Check backend availability on mount
   */
  useEffect(() => {
    const checkBackend = async () => {
      const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
      const available = await checkBackendAvailability(apiBaseUrl, 3000);

      setIsBackendAvailable(available);

      if (available) {
        console.log('✓ Backend is available - chatbot enabled');
      } else {
        console.log('✗ Backend is unavailable - chatbot hidden');
      }
    };

    checkBackend();
  }, []);

  const value = {
    config,
    isLoading,
    isHydrated,
    isBackendAvailable,
    showSlowLoader: false,
    loadMetrics: null,
    error: null,
    refreshConfig: () => {
      console.log('⚠️ refreshConfig called but not implemented (static config mode)');
    },
  };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}


